export default __webpack_public_path__ + "static/media/Group735.b0a56d9d.svg";